/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './KOL.css';

import CustomChart from '../../../components/CustomChart/CustomChart'
import { _KOL as chartKOL } from '../../../chart';
import { CustomizedForm } from '../components/baseForm'
import baseFiled from '../components/baseFiled';
import SefeImport from '../components/KOL'
import { isArray } from 'util';

const checkPx = (str) => {
  let _str = str + '';
  if (_str.indexOf('%')) {
    return _str;
  } else {
    return _str + 'px'
  }
}

class KOL extends React.Component {
  state = {
    fields: {
      ...Object.assign(baseFiled, {
        titleText: {
          value: '暴风影音受众好感图'
        },
        subTitleText: {
          value: '2019.11.20-2019.12.05'
        }
      })
    },
    list: [{
      name: '微博金V认证',
      value: 111
    }, {
      name: '微博橙V认证',
      value: 111
    }, {
      name: '微博蓝V认证',
      value: 111
    }, {
      name: '微博一般用户',
      value: 111
    }, {
      name: '微信认证账号',
      value: 888
    }, {
      name: '微信非认证账号',
      value: 999
    }, {
      name: '今日头条认证账号',
      value: 333
    }, {
      name: '今日头条非认证账号',
      value: 222
    }, {
      name: '知乎优秀回答者',
      value: 999
    }, {
      name: '知乎认证回答者',
      value: 1111
    }, {
      name: '知乎一般用户',
      value: 1222
    }],
    colorList: [{
      name: '顺意群体',
      value: 'agreeable',
      color: '#676767'
    }, {
      name: '中立群体',
      value: 'neutrality',
      color: '#bfbebf'
    }, {
      name: '逆意群体',
      value: 'reverse',
      color: '#9b9b9b'
    }],
    chartWidth: '100%',
    chartHeight: '100%',
    chartCenter: {
      x: '50%',
      y: '60%'
    },
    chart: chartKOL(),
  }
  componentDidMount () {
    this.init()
  }

  init = () => {
    const {fields, list, colorList, chartCenter} = this.state;

    const chart = chartKOL({
      ...fields,
      list,
      colorList,
      center: chartCenter
    });

    this.setState({
      chartHeight: checkPx(fields.chartHeight.value),
      chartWidth: checkPx(fields.chartWidth.value),
      chart: chart
    })
  }

  handleFormChange = (props, changedFields) => {
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        ...changedFields
      }
    }));
  }

  handleAdd = (props, changedFields) => {
    if (isArray(changedFields)) {
      this.setState({
        list: changedFields
      })
      return false
    }
    

    const color = changedFields.color;
    const center = changedFields.center;
    if (color) {
      const colorList = this.state.colorList;
      color.forEach((item, index) => { colorList[index].color = item.value });
      this.setState({
        colorList: colorList
      })
      return false
    }
    if (center) {
      this.setState({
        chartCenter: center
      })
      return false
    }
  }

  handleClick = () => {
    this.init()
  }

  render() {
    const {fields, list, colorList, chartWidth, chartHeight, chartCenter} = this.state;
    return (
      <CustomChart
        width={chartWidth}
        height={chartHeight}
        chart={this.state.chart}
        callback={this.handleClick}
      >
        <SefeImport list={list} color={colorList} center={chartCenter} onChange={this.handleAdd}></SefeImport>
        <CustomizedForm {...fields} onChange={this.handleFormChange} />
      </CustomChart>
    );
  }
}

export default withStyles(s)(KOL);



// WEBPACK FOOTER //
// src/routes/customChart/KOL/KOL.js